// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESS_INFO_REQUEST = 'FETCH_ACCESS_INFO_REQUEST';
export const FETCH_ACCESS_INFO_SUCCESS = 'FETCH_ACCESS_INFO_SUCCESS';
export const FETCH_ACCESS_INFO_FAILURE = 'FETCH_ACCESS_INFO_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ACCESS_DETAILS_REQUEST = 'FETCH_ACCESS_DETAILS_REQUEST';
export const FETCH_ACCESS_DETAILS_SUCCESS = 'FETCH_ACCESS_DETAILS_SUCCESS';
export const FETCH_ACCESS_DETAILS_FAILURE = 'FETCH_ACCESS_DETAILS_FAILURE';

// navigate to access info page
export const NAVIGATE_ACCESS_INFO = 'NAVIGATE_ACCESS_INFO';
// navigate to access details page
export const NAVIGATE_ACCESS_DETAILS = 'NAVIGATE_ACCESS_DETAILS';
